import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackSellApartmentClick } from './tracking';
import { BrokerButton } from '../../../components/BrokerButton';
import { EAvailableBrokerFlow } from '../../../repositories/newbuilding-search/entities/newbuilding_broker/NewbuildingBrokerSchema';
import { getIsNeedSelfEmployedConfirmation } from '../../../selectors/broker';
import { getCurrentJsonQuery } from '../../../selectors/location';
import { INewbuilding } from '../../../types/newbuilding';
import { getPartnerRewardsLanding, useBrokerAnalyticsUser } from '../../../utils/newbuildingBroker';
import { useNewbuildingBrokerContext } from '../../NewbuildingBrokerWidgetProvider';

interface IBrokerButtonContainerProps {
  brokerFlow: EAvailableBrokerFlow;
  newbuilding: INewbuilding;
}

export const BrokerButtonContainer: React.FC<IBrokerButtonContainerProps> = ({ brokerFlow, newbuilding }) => {
  const jsonQuery = useSelector(getCurrentJsonQuery);
  const isNeedSelfEmployedConfirmation = useSelector(getIsNeedSelfEmployedConfirmation);
  const partnerRewardsLanding = getPartnerRewardsLanding(newbuilding.newbuildingBroker);

  const openWidget = useNewbuildingBrokerContext();

  const user = useBrokerAnalyticsUser(brokerFlow);

  const [loading, setLoading] = React.useState(false);

  const openLandingOrWidget = React.useCallback(async () => {
    if (partnerRewardsLanding) {
      window.open(partnerRewardsLanding, '_blank', 'noopener');
    } else {
      setLoading(true);

      await openWidget({
        flowType: brokerFlow,
        newbuildingId: newbuilding.id,
        newbuildingRegionId: newbuilding.regionId,
        houseId: null,
        isSelfEmployed: isNeedSelfEmployedConfirmation,
        trackingParams: {
          pageType: 'ListingJK',
          siteType: 'desktop',
          user,
        },
      });

      setLoading(false);
    }
  }, [brokerFlow, jsonQuery, isNeedSelfEmployedConfirmation, newbuilding, openWidget, partnerRewardsLanding, user]);

  const handleButtonClick = React.useCallback(async () => {
    trackSellApartmentClick(jsonQuery, user);
    await openLandingOrWidget();
  }, [jsonQuery, openLandingOrWidget, user]);

  return <BrokerButton loading={loading} onClick={handleButtonClick} />;
};
